module.exports = __webpack_public_path__ + "static/img/2016@2x.08e5a4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2016@2x.png
// module id = eLd5
// module chunks = 1